/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { omitEmptyArgs, customStyle } from 'helper';
import Select from 'react-select';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  name: '',
  percentage_adjustment: '',
  ordinance_revision_id: '',
  code: '',
};

function AdjustmentFactorModal({
  getLandClassificationsList,
  landClassificationsList,
  createAdjustmentFactor,
  type,
  id,
  adjustmentFactorInfo,
  updateAdjustmentFactor,
  history,
  getAdjustmentFactorList,
  getSingleAdjustmentFactor,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState(form);
  const [dynamicFields, setDynamicFields] = useState([]);

  const validateForm = useFormValidator(formData, {
    name: 'required',
    percentage_adjustment: 'required',
    ordinance_revision_id: 'required',
    code: 'required',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!_.get(formData, 'name')) {
      Alert.warning('Name is required');
      return;
    }

    if (type === 'NEW') {
      createAdjustmentFactor(omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getAdjustmentFactorList({
          ordinance_revision_id: ordinanceRevisionId,
        });
        history.push(
          `/rpt/land/land-settings/adjustment-factor/${data.data.id}`
        );
        getSingleAdjustmentFactor(data.data.id);
      });
    }

    if (type === 'EDIT') {
      updateAdjustmentFactor(id, omitEmptyArgs(formData), (data) => {
        setModal({ isOpen: false });
        getAdjustmentFactorList({
          ordinance_revision_id: ordinanceRevisionId,
        });
        history.push(
          `/rpt/land/land-settings/adjustment-factor/${data.data.id}`
        );
        getSingleAdjustmentFactor(data.data.id);
      });
    }
  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChange = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  const handleOnChangeSelect = (key, label) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
      [label]: e.label,
    });
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        name: data.attributes.name,
        year_from: data.attributes.year_from,
        year_to: data.attributes.year_to,
        value: data.id,
      });
    });
    return newList;
  };

  const handleOrdinanceSelect = (e) => {
    setFormData({
      ...formData,
      ordinance_revision_id: e.value,
    });
  };

  const onRenderOption = (item) => {
    return (
      <table>
        <tbody>
          <tr>
            <td style={{ width: 250 }}>{item.name}</td>
            <td className="text-right" style={{ width: 100 }}>
              {item.year_from} - {item.year_to}{' '}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  useEffect(() => {
    getLandClassificationsList();
    getOrdinanceRevisionList();
  }, []);

  useEffect(() => {
    if (type === 'EDIT') {
      getLandClassificationsList();
      setFormData({
        ...formData,
        name: _.get(adjustmentFactorInfo, 'name'),
        percentage_adjustment: _.get(
          adjustmentFactorInfo,
          'percentage_adjustment'
        ),
        ordinance_revision_id: _.get(
          adjustmentFactorInfo,
          'ordinance_revision_id'
        ),
        code: _.get(adjustmentFactorInfo, 'code'),
      });
    }
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="text-muted">
              Code: {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              autoFocus
              autoComplete="none"
              name="code"
              id="code"
              onChange={handleOnChange('code')}
              value={_.get(formData, 'code') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="text-muted">
              Name: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              autoFocus
              autoComplete="none"
              name="name"
              id="name"
              onChange={handleOnChange('name')}
              value={_.get(formData, 'name') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="text-muted">
              Percentage Adjustment:{' '}
              {validateForm.renderMessage('percentage_adjustment')}
            </label>
            <input
              className="form-control"
              type="number"
              autoFocus
              autoComplete="none"
              name="percentage_adjustment"
              id="percentage_adjustment"
              onChange={handleOnChange('percentage_adjustment')}
              value={_.get(formData, 'percentage_adjustment') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Ordinance Revision:
              {validateForm.renderMessage('ordinance_revision_id')}
            </label>
            <div>
              <Select
                options={createDropdown(ordinanceRevisionList)}
                styles={customStyle}
                placeholder="Select Ordinance"
                value={
                  createDropdown(ordinanceRevisionList).filter(
                    (item) =>
                      +ordinanceRevisionId ===
                      +_.get(item, 'value')
                  ) || ''
                }
                onChange={(e) => {
                  handleOrdinanceSelect(e);
                }}
                formatOptionLabel={onRenderOption}
                isDisabled
              />
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4">
          <button
            type="submit"
            className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary  mr-1 cms-bg-color-primary"
            disabled={!validateForm.response.is_passed}
          >
            Submit
          </button>
          <button
            type="button"
            onClick={handleOnClose}
            className="btn btn-light ml-1"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AdjustmentFactorModal.defaultProps = {
  type: '',
  adjustmentFactorInfo: {},
};

AdjustmentFactorModal.propTypes = {
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  landClassificationsList: PropTypes.instanceOf(Array).isRequired,
  createAdjustmentFactor: PropTypes.instanceOf(Function).isRequired,
  updateAdjustmentFactor: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  adjustmentFactorInfo: PropTypes.instanceOf(Object),
  getAdjustmentFactorList: PropTypes.instanceOf(Function).isRequired,
  getSingleAdjustmentFactor: PropTypes.instanceOf(Function).isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  landClassificationsList:
    _.get(api, `${c.GET_LAND_CLASSIFICATIONS_LIST}.list`) || [],
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AdjustmentFactorModal);
